module.exports = __webpack_public_path__ + "img/Clock.9d9ed004.svg";